let native = `
const http = require("https");

const options = {
    method:,
    hostname:,
   port: null,
    path:,
    headers:
};

const req = http.request(options, function (res) {
    const chunks = [];

    res.on("data", function (chunk) {
        chunks.push(chunk);
    });

    res.on("end", function () {
        const body = Buffer.concat(chunks);
        console.log(body.toString());
    });
});
req.write(JSON.stringify());
req.end();`

export default (options) => {
    const url = new URL(options.url)
    const newOptions = {...options}
    const _data = {...options.data}
    delete newOptions.data
    delete newOptions.url
    newOptions.port = null
    newOptions.path = url.pathname
    newOptions.hostname = url.hostname
    native = native.replace(/{.*};/s, JSON.stringify(newOptions, null, 4))
    native = native.replace(/req.write\(JSON.stringify\(\)\);/i, `req.write(JSON.stringify(${JSON.stringify(_data, null, 4)}));`)
    return native
}